module.exports = __webpack_public_path__ + "img/rich-checked-zh.68d919ad.png";